module.exports = __webpack_public_path__ + "img/btn/button-secondary.png";


//////////////////
// WEBPACK FOOTER
// ./img/btn/button-secondary.png
// module id = 62
// module chunks = 3